import { ButtonSizes } from 'types';
export const buttonSizeDecorator = (size?: ButtonSizes) => {
	switch (size) {
		case 'small':
			return `
        height: 2rem;
        width: 4rem;
      `;
		case 'large':
			return `
        height: 4rem;
        width: 8rem;
      `;
		case 'medium':
		default:
			return `
        height: 3rem;
        width: 6rem;
      `;
	}
};
